import { useState } from "react";
import { signOutLocal } from "@/common/lib/signOut";
import { useNavigate } from "react-router";
import { ENDPOINTS } from "@/common/utils/url-registry";
import HappyDocMascot from "@/assets/hd-icons/happydoc-mascot-sticker.svg?react";
import MoneyBackGuarantee from "@/common/components/MoneyBackGuarantee";
import PlanUpgradeModal from "./PlanUpgradeModal";

export default function TrialExpiredOverlay() {
    const [showUpgradeModal, setShowUpgradeModal] = useState(false);
    const navigate = useNavigate();

    const handleSignOut = async () => {
        await signOutLocal();
        navigate(ENDPOINTS.Login);
    };

    return (
        <>
            <div className="fixed inset-0 z-40 flex items-center justify-center bg-gradient-to-br from-max-25 via-white to-shadow-25">
                {/* Decorative background blobs */}
                <div className="absolute top-0 left-0 w-[500px] h-[500px] bg-max-100 rounded-full opacity-20 blur-3xl -translate-x-1/2 -translate-y-1/2" />
                <div className="absolute bottom-0 right-0 w-[400px] h-[400px] bg-tropicana-100 rounded-full opacity-15 blur-3xl translate-x-1/3 translate-y-1/3" />

                {/* Card */}
                <div className="relative flex flex-col items-center max-w-lg w-full mx-6 px-10 py-12 bg-white/80 backdrop-blur-sm rounded-2xl shadow-xl shadow-shadow-200/30 border border-white/60 text-center">
                    {/* Mascot with glow */}
                    <div className="relative mb-6">
                        <div className="absolute inset-0 bg-max-200 rounded-full blur-2xl scale-[1.8] opacity-40" />
                        <HappyDocMascot className="relative h-28 w-28 drop-shadow-lg" />
                    </div>

                    {/* Heading */}
                    <h1 className="text-[28px] leading-tight font-semibold text-shadow-900 mb-3">
                        Your free trial has ended
                    </h1>
                    <p className="text-[15px] text-gray-500 leading-relaxed max-w-sm mb-3">
                        Thanks for trying HappyDoc! Choose a plan to keep generating medical records and using all the
                        features you love.
                    </p>

                    <div className="mb-6">
                        <MoneyBackGuarantee className="text-sm text-gray-500" />
                    </div>

                    {/* CTA */}
                    <button
                        onClick={() => setShowUpgradeModal(true)}
                        className="w-full max-w-xs rounded-xl bg-gradient-to-r from-max-500 to-max-600 px-8 py-3.5 text-[15px] font-semibold text-white shadow-lg shadow-max-500/25 hover:shadow-max-500/40 hover:from-max-600 hover:to-max-900 active:scale-[0.98] transition-all duration-200"
                    >
                        Choose a Plan
                    </button>

                    {/* Sign out link */}
                    <button
                        onClick={handleSignOut}
                        className="mt-5 text-sm text-gray-400 hover:text-gray-600 transition-colors"
                    >
                        Sign out
                    </button>
                </div>
            </div>

            <PlanUpgradeModal
                isOpen={showUpgradeModal}
                onClose={() => setShowUpgradeModal(false)}
                currentTier="trial"
                billingType="trial"
            />
        </>
    );
}
